import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Transaction } from '@app/@shared/models/transaction.model';
import { ModalController, NavController } from '@ionic/angular';
import { WalletTransactionDetailComponent } from '../wallet-transaction-detail/wallet-transaction-detail.component';
import { Timestamp } from 'firebase/firestore';
import { SorteoService } from '@app/@shared/services/sorteo.service';
import { Wallet } from '@app/@shared/models/wallet.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { PayoutService } from '@app/@shared/services/payout.service';
import { BrandingService } from '@app/@shared/services/branding.service';

@Component({
  selector: 'app-wallet-transactions',
  templateUrl: './wallet-transactions.component.html',
  styleUrls: ['./wallet-transactions.component.scss'],
})
export class WalletTransactionsComponent implements OnInit, OnChanges {
  @Input({
    required: true,
  })
  selected = 'loteria';

  @Input({
    required: true,
  })
  payoutS?: PayoutService;

  @Input({
    required: true,
  })
  transactions: string = '';
  @Input({
    required: true,
  })
  isLoading = false;
  @Input({
    required: true,
  })
  wallets: Wallet[] = [];
  selectedFilter: string = 'all'; // Default filter

  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalPages: number = 0;
  @Input({
    required: true,
  })
  sorteoS?: SorteoService;

  @Output() updateTransactions = new EventEmitter<boolean>();

  filterTransactions(ev: any) {
    this.selectedFilter = ev['detail']['value'];
    this.currentPage = 1;
    this.filterTransaction();
  }

  getTransactionIcon(type: string): string {
    type = this.getType(type);
    switch (type) {
      case 'refund':
        return './assets/icons/transaction_types/refund.svg';
      case 'withdrawal':
        return './assets/icons/transaction_types/withdrawal.svg';
      case 'deposit':
        return './assets/icons/transaction_types/deposit.svg';
      case 'purchase':
        return './assets/icons/transaction_types/game.svg';
      case 'prize':
        return './assets/icons/transaction_types/prize.svg';
      case 'bonus':
        return './assets/icons/transaction_types/prize.svg';
      default:
        return './assets/icons/transaction_types/deposit.svg';
    }
  }

  getTransactionColor(amount: number): string {
    return amount > 0 ? 'green' : 'red';
  }
  constructor(
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private firestore: AngularFirestore,
    public brandingService: BrandingService
  ) {}
  filteredTransaction: Transaction[] = [];

  filterTransaction() {
    const walletUsed = this.wallets.filter((w) => w.walletName.includes(this.selected));
    //console.log(walletUsed);

    if (this.selectedFilter === 'casino' || this.selectedFilter === 'book') {
      let filtered: Transaction[] = JSON.parse(this.transactions, this.reviver).filter(
        (tx: Transaction) => tx.data && tx.data.product === this.selectedFilter
      );

      // filtrar por las wallets
      filtered =
        this.selected === 'loteria'
          ? [...filtered]
          : [
              ...filtered
                .filter((f) => {
                  if (f.type.includes('purchase')) {
                    // para las compras
                    return (
                      f.data.walletsUsed &&
                      f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                    );
                  } else if (f.type.includes('refund')) {
                    // compras devueltas
                    return (
                      f.data.walletsUsed &&
                      f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                    );
                  } else if (f.type.includes('withdrawal')) {
                    // solicitudes de retiro
                    return (
                      f.data.walletsUsed &&
                      f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                    );
                  } else if (f.type.includes('revers')) {
                    // premios devueltos
                    return (
                      f.data.walletsUsed &&
                      f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                    );
                  } else if (f.type.includes('prize')) {
                    // premios pagadps
                    return (
                      f.data.walletsUsed &&
                      f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                    );
                  } else if (f.type.includes('bonus')) {
                    // bonos liberados
                    return walletUsed.some((w) => w.id === f.walletId.id);
                  } else if (f.type.includes('discount')) {
                    // descuentos en carteras
                    return walletUsed.some((w) => w.id === f.walletId.id);
                  } else if (f.type.includes('coupon') || f.type.includes('wallet_coupon_redeem')) {
                    // Canje de cupones y referidos
                    return walletUsed.some((w) => w.id === f.walletId?.id);
                  }
                })
                .map((f) => {
                  if (f.type.includes('purchase')) {
                    const amount = (
                      f.data.walletsUsed as {
                        id: string;
                        amount: number;
                      }[]
                    )
                      .filter((u) => walletUsed.some((w) => w.id === u.id))
                      .reduce((a, b) => a + b.amount, 0);

                    f.amount = amount;
                  } else if (f.type.includes('refund')) {
                    const amount = (
                      f.data.walletsUsed as {
                        id: string;
                        amount: number;
                      }[]
                    )
                      .filter((u) => walletUsed.some((w) => w.id === u.id))
                      .reduce((a, b) => a + b.amount, 0);
                    f.amount = amount;
                  }

                  return f;
                }),
            ];

      this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);
      // Pagination logic inside the getter
      const start = (this.currentPage - 1) * this.itemsPerPage;
      this.filteredTransaction = [...filtered.slice(start, start + this.itemsPerPage)];
      return;
    }
    // realizar primer filtro
    let filtered: Transaction[] = JSON.parse(this.transactions, this.reviver).filter(
      (tx: Transaction) => this.selectedFilter === 'all' || this.getType(tx) === this.selectedFilter
    );

    // filtrar por las wallets
    filtered =
      this.selected === 'loteria'
        ? [...filtered]
        : [
            ...filtered
              .filter((f) => {
                if (f.type.includes('purchase')) {
                  // para las compras
                  return (
                    f.data.walletsUsed &&
                    f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                  );
                } else if (f.type.includes('refund')) {
                  // compras devueltas
                  return (
                    f.data.walletsUsed &&
                    f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                  );
                } else if (f.type.includes('withdrawal')) {
                  // solicitudes de retiro
                  return (
                    f.data.walletsUsed &&
                    f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                  );
                } else if (f.type.includes('revers')) {
                  // premios devueltos
                  return (
                    f.data.walletsUsed &&
                    f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                  );
                } else if (f.type.includes('prize')) {
                  // premios pagadps
                  return (
                    f.data.walletsUsed &&
                    f.data.walletsUsed.some((u: { id: string }) => walletUsed.some((w) => w.id === u.id))
                  );
                } else if (f.type.includes('bonus')) {
                  // bonos liberados
                  return walletUsed.some((w) => w.id === f.walletId.id);
                } else if (f.type.includes('discount')) {
                  // descuentos en carteras
                  return walletUsed.some((w) => w.id === f.walletId.id);
                } else if (f.type.includes('coupon') || f.type.includes('wallet_coupon_redeem')) {
                  // Canje de cupones y referidos
                  return walletUsed.some((w) => w.id === f.walletId?.id);
                }
              })
              .map((f) => {
                if (f.type.includes('purchase')) {
                  const amount = (
                    f.data.walletsUsed as {
                      id: string;
                      amount: number;
                    }[]
                  )
                    .filter((u) => walletUsed.some((w) => w.id === u.id))
                    .reduce((a, b) => a + b.amount, 0);

                  f.amount = amount;
                } else if (f.type.includes('refund')) {
                  const amount = (
                    f.data.walletsUsed as {
                      id: string;
                      amount: number;
                    }[]
                  )
                    .filter((u) => walletUsed.some((w) => w.id === u.id))
                    .reduce((a, b) => a + b.amount, 0);
                  f.amount = amount;
                }

                return f;
              }),
          ];

    this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);
    // Pagination logic inside the getter
    const start = (this.currentPage - 1) * this.itemsPerPage;
    this.filteredTransaction = [...filtered.slice(start, start + this.itemsPerPage)];
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.filterTransaction();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.filterTransaction();
    }
  }

  ngOnInit() {
    this.processTransactions();
  }

  processTransactions() {
    // FILTRAR TRANSACTIONS PENDIENTES MUY ANTIGUAS, DE MAS DE UNA SEMANA
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);

    let parsedList = JSON.parse(this.transactions, this.reviver).filter(
      (tx: Transaction) =>
        tx.amount !== 0 && (tx.status !== 'pending' || (tx.createdAt.toDate() as Date).getTime() >= weekAgo.getTime())
    );

    if (this.brandingService.isMidiadesuerte()) {
      parsedList = parsedList.filter(
        (tx: Transaction) =>
          !(tx.data?.product === 'casino') &&
          !(tx.data?.product === 'book') &&
          !tx.type.includes('book') &&
          !tx.type.includes('casino')
      );
    }

    this.transactions = JSON.stringify(parsedList);
    this.totalPages = Math.ceil(parsedList.length / this.itemsPerPage);
    this.filterTransaction();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selected']) {
      // Aquí puedes ejecutar lógica cuando selected cambia
      this.filterTransaction();
    }

    if (changes['transactions']) {
      this.processTransactions();
    }
  }

  goTo(to: string[]) {
    this.navCtrl.navigateForward(to);
  }

  getType(t: Transaction | string): string {
    const type = typeof t === 'string' ? t : t.type;
    if (type.includes('wallet_coupon_redeem')) return 'coupon';
    if (type.includes('wallet-purchase')) return 'purchase';
    if (type.includes('wallet_recharge_user') || type === 'wallet_recharge_admin') {
      return 'deposit';
    }

    if (type.includes('wallet_prize_award')) return 'prize';
    if (type.includes('cashback') || type.includes('refund')) {
      if (type.includes('reversal')) return 'discount';
      return 'refund';
    }

    if (type.includes('transfer_out')) return 'transfer_out';
    if (type.includes('transfer_in')) return 'transfer_in';
    if (type.includes('bonus_in')) return 'bonus';
    if (type.includes('wallet_withdrawal') || type === 'wallet_prize_reversal') return 'withdrawal';
    if (type.includes('discount')) return 'discount';
    if (type.includes('prize_payout')) return 'withdrawal';

    return '';
  }

  isIncrement(t: Transaction): boolean {
    if (t.type.includes('wallet_coupon_redeem')) return true;
    if (t.type.includes('wallet_recharge_user') || t.type === 'wallet_recharge_admin') return true;

    if (t.type.includes('wallet_prize_award')) return true;
    if (t.type.includes('cashback') || (t.type.includes('refund') && !t.type.includes('reversal'))) return true;

    if (t.type.includes('_in')) return true;

    return false;
  }

  getCouponDescription(transaction: Transaction): string {
    try {
      let data = transaction.data;
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
      const code = data?.code || data?.couponCode || '';

      if (code === 'REFERRAL-REWARD') {
        return 'Bono por Referido Activo';
      }

      // Si el código es numérico, es un código de referido
      const isNumeric = /^\d+$/.test(code);
      if (isNumeric) {
        return `Cupón de referido (${code})`;
      }

      if (code) {
        return `Canje de Cupón (${code})`;
      }
      return 'Canje de Cupón';
    } catch (e) {
      return 'Canje de Cupón';
    }
  }

  async transactionClick(transaction: Transaction) {
    const t = JSON.parse(this.transactions, this.reviver).find((tr: Transaction) => tr.uid === transaction.uid)!;

    const modal = await this.modalCtrl.create({
      component: WalletTransactionDetailComponent,
      componentProps: {
        transaction: t,
        created: (t.createdAt as Timestamp).toDate(),
        type: this.getType(t),
        refund: JSON.parse(this.transactions, this.reviver).some((tr: Transaction) =>
          tr.refunds?.some((d) => d.id === t.uid)
        ),
        sorteoS: this.sorteoS,
        selected: this.selected,
        wallets: this.wallets,
        payoutS: this.payoutS,
      },
      cssClass: 'transaction-detail',
    });

    await modal.present();

    const { role } = await modal.onWillDismiss();

    if (role === 'reviver') {
      this.updateTransactions.emit(true);
    }
  }

  private reviver = (key: string, value: any): any => {
    const timestampKeys = ['createdAt', 'modifiedAt'];
    const referenceKeys = ['gameId', 'walletId', 'customerId', 'discountId'];

    // 1. Revivir Timestamp
    if (
      timestampKeys.includes(key) &&
      typeof value === 'object' &&
      value !== null &&
      'seconds' in value &&
      'nanoseconds' in value
    ) {
      // Asegúrate de que los tipos sean correctos
      return new Timestamp(value.seconds, value.nanoseconds);
    }

    // 2. Revivir DocumentReference
    if (
      referenceKeys.includes(key) &&
      typeof value === 'string' &&
      value.includes('/') // Validar que sea una ruta
    ) {
      return this.firestore.doc(value).ref; // ← .ref devuelve DocumentReference
    }

    return value;
  };
}
